import { mapToObjectDDL } from "../../common/mapper";
import { v4 as uuidv4 } from "uuid";
import * as R from "ramda";
import moment from "moment";

export const getCategoryType = (type) => {
  switch (type) {
    case "Job":
      return "JOB_TYPE";
    case "Part":
      return "PART_TYPE";
    default:
      return "JOB_TYPE";
  }
};

export const initialDataDetail = {
  Job: {
    id: null,
    kode: null,
    name: null,
    category: null,
    estimasiWaktu: null,
    saved: false,
  },
  Part: {
    id: null,
    kode: null,
    name: null,
    category: null,
    satuan: null,
    jumlah: null,
    saved: false,
  },
};

export const getDataDetail = (type, data) => {
  if (!Array.isArray(data)) return [];

  switch (type) {
    case "Job":
      return data.map((item) => ({
        id: uuidv4(),
        serviceCode: mapToObjectDDL(item.serviceCode, item.serviceCode),
        serviceName: mapToObjectDDL(item.serviceName, item.serviceCode),
        serviceCategory: item.serviceCategory,
        estimationTime: item.estimationTime,
        saved: true,
      }));

    case "Part":
      return data.map((item) => ({
        id: uuidv4(),
        kodePart: mapToObjectDDL(item.kodePart, item.kodePart),
        partName: mapToObjectDDL(item.partName, item.kodePart),
        partCategory: item.partCategory,
        satuan: item.satuan,
        partQty: item.partQty,
        saved: true,
      }));

    default:
      return [];
  }
};

export const getValueItemFromArrayDDL = (object, key) => {
  if (
    object?.[key] === undefined ||
    R.isNil(object[key]) ||
    R.isEmpty(object[key])
  ) {
    return [];
  }

  const arr = object[key].value;
  if (!Array.isArray(arr)) return [];

  if (key === "part") {
    return arr.map((item) => ({
      kodePart: item.kodePart?.value || item.kodePart || null,
      partQty: Number(item.partQty) || 0,
    }));
  }
  if (key === "service") {
    return arr.map((item) => ({
      serviceCode: item.serviceCode?.value || item.serviceCode || null,
      estimationTime: Number(item.estimationTime) || 0,
    }));
  }

  return [];
};

export const validateDataItem = (obj, activeTab) => {
  const errors = {};

  if (activeTab === "Job") {
    if (!obj.serviceCode?.value) errors.serviceCode = "Field wajib diisi";
    if (!obj.serviceName?.value) errors.serviceName = "Field wajib diisi";
  }

  if (activeTab === "Part") {
    if (!obj.kodePart?.value) errors.kodePart = "Field wajib diisi";
    if (!obj.partName?.value) errors.partName = "Field wajib diisi";
    if (!obj.partQty || Number(obj.partQty) <= 0)
      errors.partQty = "Field wajib diisi";
  }

  return errors;
};

export const filterInitialValue = {
  kodeCabang: [],
  kodeVariant: null,
  packageName: null,
  hasGracePeriod: null,
  period: null,
  startDate: null,
  endDate: null,
};
